<template>
  <section class="sharkbet-game-history" :class="`sharkbet-game-history--${variant}`">
    <h2>HISTORIAL DE JUEGO</h2>
    <form class="sharkbet-game-history__filters" @submit.prevent="fetchHistory">
      <label>Fecha de inicio
        <input v-model="startDate" type="date" @change="fetchHistory">
      </label>
      <label>Fecha final
        <input v-model="endDate" type="date" @change="fetchHistory">
      </label>
      <label class="sharkbet-game-history__search">Filtrar resultados
        <input v-model.trim="search" type="search" placeholder="Buscar">
      </label>
      <button type="button" @click="search = ''">Limpiar</button>
    </form>

    <div class="sharkbet-game-history__table-wrap">
      <div v-if="loading" class="sharkbet-game-history__loading"><div class="spinner-border" role="status"></div></div>
      <table v-else class="sharkbet-game-history__table">
        <thead><tr><th>Fecha</th><th>Proveedor</th><th>Detalle</th><th>Monto</th><th>Saldo</th><th>Reclamo</th></tr></thead>
        <tbody>
          <tr v-for="(item, index) in visibleRecords" :key="index">
            <td>{{ formatDate(item.fecha) }}</td><td>{{ item.proveedor }}</td><td>{{ item.operacion }}</td><td>{{ formatAmount(item.valor) }}</td><td>{{ formatAmount(item.nuevo_capital) }}</td><td><i class="fa-regular fa-comment-dots"></i></td>
          </tr>
          <tr v-if="filteredRecords.length === 0"><td colspan="6">No hay registros</td></tr>
        </tbody>
      </table>
    </div>
    <div class="sharkbet-game-history__footer">
      <span>{{ filteredRecords.length }} Registros</span>
      <button v-if="visibleRecords.length < filteredRecords.length" type="button" @click="visibleCount += 12">Mostrar mas</button>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SharkbetGameHistory',
  props: {
    autoLoad: { type: Boolean, default: false },
    variant: { type: String, default: 'desktop' },
  },
  data() {
    return {
      endDate: '2030-12-31',
      loading: false,
      records: [],
      search: '',
      startDate: '2020-01-01',
      visibleCount: 12,
    };
  },
  computed: {
    apiUrl() { return this.$store.getters['getApiUrlnew']; },
    user() { return this.$store.getters['getUserData']; },
    filteredRecords() {
      const search = this.search.toLowerCase();
      if (!search) return this.records;
      return this.records.filter((item) => Object.values(item).join(' ').toLowerCase().includes(search));
    },
    visibleRecords() { return this.filteredRecords.slice(0, this.visibleCount); },
  },
  methods: {
    async fetchHistory() {
      if (!this.user.token || this.loading) return;

      this.loading = true;
      this.visibleCount = 12;
      try {
        const response = await axios.get(`${this.apiUrl}records/historial-jugador`, {
          headers: { 'x-player-token': this.user.token, 'x-api-key': 'FTBBW4bR1pKTUFsURbFD8RpcPygh8wN6' },
          params: {
            username: this.user.user_data?.data?.user_name,
            startDate: `${this.startDate} 00:00:00`,
            endDate: `${this.endDate} 23:59:59`,
            timezone: '-05:00',
          },
        });
        this.records = Array.isArray(response.data) ? response.data : response.data?.data || [];
      } catch {
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    formatAmount(value) {
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value || 0);
    },
    formatDate(value) {
      const date = new Date(value);
      const pad = (number) => String(number).padStart(2, '0');
      return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
  mounted() {
    if (this.autoLoad) this.fetchHistory();
    this.$root.$on('getMovementsHistory', this.fetchHistory);
  },
  beforeDestroy() {
    this.$root.$off('getMovementsHistory', this.fetchHistory);
  },
};
</script>

<style scoped>
.sharkbet-game-history h2 {
  color: #17212a;
  font: 400 30px 'Roboto', sans-serif;
  margin: 0 0 26px;
}

.sharkbet-game-history__filters {
  background: #f6f6f6;
  border-radius: 14px;
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 8px;
  padding: 16px;
}

.sharkbet-game-history__filters label {
  color: #17212a;
  display: grid;
  font: 500 12px 'Roboto', sans-serif;
  gap: 5px;
}

.sharkbet-game-history__filters input {
  background: #fff;
  border: 1px solid #c8c8c8;
  border-radius: 22px;
  color: #5f6972;
  font: 12px 'Roboto', sans-serif;
  height: 29px;
  min-width: 0;
  padding: 0 10px;
  width: 100%;
}

.sharkbet-game-history__search {
  grid-column: 1;
}

.sharkbet-game-history__filters button {
  align-self: end;
  background: #fff;
  border: 1px solid #009fe3;
  border-radius: 18px;
  color: #008ccd;
  cursor: pointer;
  font: 500 12px 'Roboto', sans-serif;
  height: 29px;
  justify-self: start;
  padding: 0 14px;
}

.sharkbet-game-history__table-wrap {
  border: 1px solid #52606a;
  border-radius: 14px;
  overflow-x: auto;
}

.sharkbet-game-history__table {
  border-collapse: separate;
  border-spacing: 0;
  color: #7a8790;
  font: 12px 'Roboto', sans-serif;
  min-width: 680px;
  width: 100%;
}

.sharkbet-game-history__table th {
  background: #0089b8;
  border-right: 1px solid #52606a;
  color: #fff;
  font-weight: 600;
  padding: 13px 8px;
  text-align: center;
}

.sharkbet-game-history__table th:first-child { border-radius: 13px 0 0 0; }
.sharkbet-game-history__table th:last-child { border-radius: 0 13px 0 0; border-right: 0; }

.sharkbet-game-history__table td {
  background: #fafafa;
  border-right: 1px solid #52606a;
  border-top: 1px solid #52606a;
  padding: 11px 8px;
  text-align: center;
}

.sharkbet-game-history__table td:last-child { border-right: 0; }
.sharkbet-game-history__table tbody tr:nth-child(even) td { background: #f0f0f0; }
.sharkbet-game-history__table tbody tr:last-child td:first-child { border-radius: 0 0 0 13px; }
.sharkbet-game-history__table tbody tr:last-child td:last-child { border-radius: 0 0 13px 0; }
.sharkbet-game-history__table td[colspan] { border-radius: 0 0 13px 13px; padding: 24px; }

.sharkbet-game-history__loading { color: #008ccd; padding: 34px; text-align: center; }

.sharkbet-game-history__footer {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.sharkbet-game-history__footer span {
  color: #7a8790;
  font: 12px 'Roboto', sans-serif;
}

.sharkbet-game-history__footer button {
  background: #0092cd;
  border: 0;
  border-radius: 18px;
  color: #fff;
  cursor: pointer;
  font: 600 12px 'Roboto', sans-serif;
  height: 29px;
  justify-self: start;
  padding: 0 14px;
}

@media (max-width: 767px) {
  .sharkbet-game-history__filters { grid-template-columns: 1fr; }
  .sharkbet-game-history__search { grid-column: auto; }
}
</style>
